import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const outcomes = ['Build a fragrance-free routine for laundry, bath, and bedding that you can actually maintain', "Stop falling for the 'unscented' trap and other label confusion", 'Remove the highest-impact triggers without turning your house upside down', "Handle daycare and relatives with calm scripts (so you're not the 'product police')", 'Use a flare-up checklist that keeps you strategic instead of spiraling'];
const failures = ['“Switch to clean products” (too vague)', '“Avoid triggers” (which ones? where?)', '“Try this brand” (formulas change)', '“Do an elimination” (changes 12 things at once)'];
export function BenefitsSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="mb-20" data-id="element-3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-[#2D2D2D] mb-10 text-center" data-id="element-4">
            What you'll be able to do by Day 14
          </motion.h2>

          <div className="space-y-4" data-id="element-5">
            {outcomes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 p-4 rounded-lg hover:bg-[#F5F1E8]/50 transition-colors" data-id="element-6">
                <CheckCircle2 className="w-6 h-6 text-[#8B9D83] shrink-0 mt-0.5" data-id="element-7" />
                <p className="text-lg text-[#4A4A4A]" data-id="element-8">{item}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#F5F1E8] rounded-2xl p-8 md:p-12" data-id="element-9">
          <h3 className="text-2xl font-serif text-[#2D2D2D] mb-6" data-id="element-10">
            Why what you tried before didn't stick
          </h3>
          <p className="text-lg text-[#5A5A5A] mb-8" data-id="element-11">
            Because it wasn't built like a system. Most advice tells you to:
          </p>

          <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-12">
            {failures.map((fail, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg border border-[#E5E5E5]" data-id="element-13">
                <XCircle className="w-5 h-5 text-[#D4A59A] shrink-0" data-id="element-14" />
                <span className="text-[#4A4A4A]" data-id="element-15">{fail}</span>
              </div>)}
          </div>

          <div className="text-center border-t border-[#D4A59A]/20 pt-8" data-id="element-16">
            <p className="text-xl font-serif font-medium text-[#2D2D2D]" data-id="element-17">
              You don't need more advice.{' '}
              <span className="text-[#D4A59A]" data-id="element-18">You need a sequence.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}